var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { settingsApi } from '@data/rest/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { SettingType } from '@common/api';
import { useEffect, useState } from 'react';
import { useLanguage } from '@base/LanguageProvider';
import { useTagContext } from '@data/tag/tagContext';
import { useTagActions } from '@data/tag/tagActions';
var QUERY_KEY = ['settings'];
function updateSetting(setting) {
    return __awaiter(this, void 0, void 0, function () {
        var value, key, error_1, err, errJSON;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = setting.value, key = setting.key;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, settingsApi.update(key, { value: value })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    return [4 /*yield*/, error_1.text()];
                case 4:
                    err = _a.sent();
                    errJSON = JSON.parse(err);
                    throw errJSON;
                case 5: return [2 /*return*/, setting];
            }
        });
    });
}
export function useSettings() {
    var _a = useQuery(QUERY_KEY, function () { return settingsApi.list(); }, {
        staleTime: 5000,
    }), data = _a.data, isError = _a.isError;
    return isError ? [] : data !== null && data !== void 0 ? data : [];
}
export function useSetting(key) {
    var settings = useSettings();
    return settings.find(function (s) { return s.key === key; });
}
export function useSettingUpdate() {
    var queryClient = useQueryClient();
    var oldSettings = useSettings();
    var mutation = useMutation(updateSetting, {
        onSuccess: function (updatedSetting) {
            var targetIdx = oldSettings.findIndex(function (s) { return s.id === updatedSetting.id; });
            oldSettings[targetIdx] = updatedSetting;
            queryClient.setQueryData(QUERY_KEY, oldSettings);
        },
        onSettled: function () {
            queryClient.refetchQueries(QUERY_KEY);
        },
    });
    return mutation;
}
function moveElementsToEndOfArray(moveFromIdx) {
    var arr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    return __spreadArray(__spreadArray([], __read(arr.slice(moveFromIdx, arr.length)), false), __read(arr.slice(0, moveFromIdx)), false);
}
export function useFinancialYearUpdate() {
    var _this = this;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var internalTags = tagData.internalTagsMap;
    var editTag = useTagActions().editTag;
    var monthTags = internalTags.months;
    var ytdTags = internalTags.yearToDate;
    var data = useSetting(SettingType.FinancialYearStartingMonth);
    var _a = __read(useState(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = __read(useState(false), 2), isSuccess = _b[0], setIsSuccess = _b[1];
    var _c = __read(useState(false), 2), isError = _c[0], setIsError = _c[1];
    var _d = __read(useState(null), 2), error = _d[0], setError = _d[1];
    var updatedSetting = useSettingUpdate();
    var updateFinancialYear = function (setting) {
        setIsLoading(true);
        updatedSetting.mutate(setting);
    };
    useEffect(function () {
        if (updatedSetting.isError) {
            setIsLoading(false);
            setIsError(updatedSetting.isError);
            setError(updatedSetting.error);
        }
    }, [updatedSetting.isError, updatedSetting.error]);
    var handleMonthNames = function (n) { return __awaiter(_this, void 0, void 0, function () {
        var newMonthsDescriptions, index, month, index, ytd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newMonthsDescriptions = moveElementsToEndOfArray(n);
                    index = 0;
                    _a.label = 1;
                case 1:
                    if (!(index < monthTags.length)) return [3 /*break*/, 4];
                    month = monthTags[index];
                    return [4 /*yield*/, editTag(__assign(__assign({}, month), { description: newMonthsDescriptions[index] }))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    index++;
                    return [3 /*break*/, 1];
                case 4:
                    index = 0;
                    _a.label = 5;
                case 5:
                    if (!(index < ytdTags.length)) return [3 /*break*/, 8];
                    ytd = ytdTags[index];
                    return [4 /*yield*/, editTag(__assign(__assign({}, ytd), { description: newMonthsDescriptions[index] }))];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    index++;
                    return [3 /*break*/, 5];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        if (updatedSetting.isSuccess) {
            handleMonthNames(parseInt((_a = data === null || data === void 0 ? void 0 : data.value) !== null && _a !== void 0 ? _a : 1) - 1)
                .then(function () {
                setIsError(false);
                setError(null);
                setIsLoading(false);
                setIsSuccess(true);
            })
                .catch(function () {
                setIsError(true);
                setError({ message: L('Descriptions update for month and year to date tags failed.') });
                setIsLoading(false);
                setIsSuccess(false);
            });
        }
    }, [updatedSetting.isSuccess]);
    return {
        mutate: updateFinancialYear,
        data: data,
        error: error,
        isError: isError,
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
}
